// BRAND LIST
$(document).ready(function () {
	$(".brand-list .logo-slider").slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 2000,
		infinite: false,
		responsive: [
			{
				breakpoint: 968,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 520,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: false,
					autoplay: true,
					autoplaySpeed: 2000,
				},
			},
		],
	});
});

// New Arrivals section | product image-hover
jQuery(document).ready(function ($) {
	$(document).on("mouseover", "  .new-products-item", function () {
		let id = $(this).find(".new-product-item-image").attr("data-product-id"),
			img = $(this).find(".new-product-item-image img"),
			srcSet = img.attr("srcset");

		img.attr({
			src: getHoverImg(id),
			prevSrcset: srcSet,
		})
			.removeAttr("srcset")
			.addClass("hoverState");
	});

	$(document).on("mouseout", ".new-products-item ", function () {
		let img = $(this).find(".new-product-item-image img"),
			srcSet = img.attr("prevSrcset");

		img.attr("srcset", srcSet)
			.removeAttr("prevSrcset")
			.removeClass("hoverState");
	});

	function getHoverImg(id) {
		let img = "";

		switch (id) {
			case "9367330702":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_1.jpg?v=1651480941";
				break;
			case "9256082638":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_2.jpg?v=1651480941";
				break;
			case "1598725455943":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_13.jpg?v=1651480941";
				break;
			case "6611256082503":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_4.jpg?v=1651480941";
				break;
			default:
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_1.jpg?v=1651480941";
		}

		return img;
	}
});

// Best Sellers section | product image-hover
jQuery(document).ready(function ($) {
	$(document).on("mouseover", " .best-sellers-products-item", function () {
		let id = $(this)
				.find(".best-sellers-product-item-image")
				.attr("data-product-id"),
			img = $(this).find(".best-sellers-product-item-image img"),
			srcSet = img.attr("srcset");

		img.attr({
			src: getHoverImg(id),
			prevSrcset: srcSet,
		})
			.removeAttr("srcset")
			.addClass("hoverState");
	});

	$(document).on("mouseout", ".best-sellers-products-item ", function () {
		let img = $(this).find(".best-sellers-product-item-image img"),
			srcSet = img.attr("prevSrcset");

		img.attr("srcset", srcSet)
			.removeAttr("prevSrcset")
			.removeClass("hoverState");
	});

	function getHoverImg(id) {
		let img = "";

		switch (id) {
			case "9367330702":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_1.jpg?v=1651480941";
				break;
			case "9256082638":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_2.jpg?v=1651480941";
				break;
			case "1598725455943":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_13.jpg?v=1651480941";
				break;
			case "6611256082503":
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_4.jpg?v=1651480941";
				break;
			default:
				img =
					"https://cdn.shopify.com/s/files/1/1429/7340/files/hover-New_Arrivals_1.jpg?v=1651480941";
		}

		return img;
	}
});

//modal close
$(".close").click(function () {
	$("#videoModal iframe").attr("src", $("#videoModal iframe").attr("src"));
});

// NEW FEATURED COLLECTION
$(document).ready(function () {
	$(".collection-list").slick({
		dots: true,
		arrows: true,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});
});

//REMOVE EXTENDED WARRANTY FROM PRODUCT RECOMMENDATIONS
document.addEventListener("DOMContentLoaded", function () {
	const warrantyHandle = "extend-f89f5b87-6eac-4ce8-86fd-1352303dc8a8";

	function hideWarrantyProducts() {
		const productCards = document.querySelectorAll(
			".product-recommendations .grid-item, .product-recommendations .product-item, .product-recommendations .product-card, " +
				".recently-viewed .sf__pcard, .recently-viewed .sf-column, " +
				'[data-section-type="recently-viewed"] .sf__pcard, [data-section-type="recently-viewed"] .sf-column, ' +
				'[data-section-id*="recent-viewed"] .sf__pcard, [data-section-id*="recent-viewed"] .sf-column'
		);

		productCards.forEach((card) => {
			const links = card.querySelectorAll(
				`a[href*="/products/${warrantyHandle}"]`
			);

			if (links.length > 0) {
				card.style.display = "none";
			}
		});
	}

	hideWarrantyProducts();

	const observer = new MutationObserver(function () {
		hideWarrantyProducts();
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
});
